import { useId } from 'react';
import { useTranslation } from 'react-i18next';
import { FORM_LABEL_TYPE } from '@/lib/typography';
import { cn } from '@/utils/cn';
import { FieldHint } from './Field';
import { Radio } from './Radio';

export function VatMomsField({
  includesVat,
  clinicRatePercent,
  onChange,
  disabled,
  className,
  name,
}: {
  includesVat: boolean;
  clinicRatePercent: number;
  onChange: (includesVat: boolean) => void;
  disabled?: boolean;
  className?: string;
  name?: string;
}) {
  const { t } = useTranslation();
  const groupId = useId();
  const fieldName = name ?? groupId;

  return (
    <fieldset className={cn('min-w-0', className)} disabled={disabled}>
      <legend className={cn('block', FORM_LABEL_TYPE)}>{t('vat.field_label')}</legend>
      <div className="mt-2 space-y-2">
        <Radio
          name={fieldName}
          checked={includesVat}
          onChange={() => onChange(true)}
          disabled={disabled}
          label={t('vat.with_vat')}
        />
        <Radio
          name={fieldName}
          checked={!includesVat}
          onChange={() => onChange(false)}
          disabled={disabled}
          label={t('vat.without_vat')}
        />
      </div>
      {includesVat ? (
        <FieldHint>{t('vat.clinic_rate_hint', { rate: clinicRatePercent })}</FieldHint>
      ) : null}
    </fieldset>
  );
}
